import React from 'react'
import { useTranslation } from 'react-i18next'
import Link from '../Link'

function ChangelogLink({ href }) {
  const { t } = useTranslation()

  return <Link href={href}>{t('changelog.page.viewChange')}</Link>
}

export default ChangelogLink
